import React from 'react';
import { StoreApi } from 'zustand';

export type TermsOfConsentStore = {
    showTermsOfUseWithCheckBox: boolean;
    isConsentTermsOfUseChecked: boolean;
    showConsentTermsOfUseNotification: boolean;
};

export type TermsOfConsentStoreFunction = {
    setShowTermsOfUseWithCheckBox: (showTermsOfUseWithCheckBox: boolean) => void;
    setIsConsentTermsOfUseChecked: (isConsentTermsOfUseChecked: boolean) => void;
    setShowConsentTermsOfUseNotification: (showConsentTermsOfUseNotification: boolean) => void;
};

export type TermsOfConsentContextProps = {
    termsOfConsentStore: StoreApi<TermsOfConsentStore & TermsOfConsentStoreFunction>;
};

const TermsOfConsentContext = React.createContext<TermsOfConsentContextProps | null>(null);
TermsOfConsentContext.displayName = 'TermsOfConsentContext';
export { TermsOfConsentContext };
